import InsertOfferWrapper from "components/InsertOfferWrapper";
import LocationForm from "scenes/InsertOffer/form/Location";
import { CustomAppPage } from "src/types/types";

const Location: CustomAppPage = () => (
  <InsertOfferWrapper title="Adresa nemovitosti">
    <LocationForm buttonNextText="Další" />
  </InsertOfferWrapper>
);

Location.hasHiddenFooter = true;

export default Location;
